import React, {
  useEffect,
  useRef,
  useLayoutEffect,
  useState,
  useMemo,
} from "react";
import Tooltip from "antd/lib/tooltip";
import isEqual from "react-fast-compare";
import "./CompetitorBrandLabels.scss";
import { useSelector } from "react-redux";
import { getPaneIndex } from "../../../../redux/constants";
const CompetitorBrandLabels = ({
  pills,
  comp_brands = null,
  comp_brands_length = 0,
}) => {
  const divRefParent = useRef(null);
  const divRefInner = useRef(null);
  const pillsRefs = useRef([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [visiblePills, setVisiblePills] = useState([]);
  const [hiddenPills, setHiddenPills] = useState([]);
  const [refreshUIOnBrandChange, setRefreshUIOnBrandChange] = useState(false);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  let index = getPaneIndex(panes, activeKey);
  // const calculateWidth = () => {
  //   if (divRefInner?.current) {
  //     window.requestAnimationFrame(() => {
  //       const parentWidth = divRefParent?.current?.offsetWidth;
  //       const innerWidth = divRefParent?.current?.offsetWidth - 70;

  //       let totalWidth = 0;
  //       let visiblePillsIndices = [];
  //       let hiddenPillsArray = [];

  //       pillsRefs?.current?.forEach((pillRef, index) => {
  //         if (pillRef) {
  //           const pillWidth = pillRef?.offsetWidth;
  //           totalWidth += pillWidth;

  //           if (totalWidth <= innerWidth) {
  //             visiblePillsIndices?.push(index);
  //           } else {
  //             hiddenPillsArray?.push(index);
  //           }
  //         }
  //       });

  //       setVisiblePills(visiblePillsIndices);
  //       setHiddenPills(hiddenPillsArray);
  //     });
  //   }
  // };

  // useLayoutEffect(() => {
  //   calculateWidth();

  //   const handleResize = () => {
  //     window.requestAnimationFrame(calculateWidth);
  //   };

  //   window.addEventListener("resize", handleResize);

  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, []);
  const handleWindowResize = () => {
    setWindowWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  useEffect(() => {
    setRefreshUIOnBrandChange(!refreshUIOnBrandChange);
  }, [
    panes?.[index]?.brands,
    panes?.[index]?.brand_ids,
    panes?.[index]?.brand_groups,
  ]);
  const comptitorBrandList = useMemo(() => {
    let updatedBrandList = [];
    if (comp_brands) {
      let parentBrand = {
        brand_name: comp_brands?.brand_friendly_name
          ? comp_brands?.brand_friendly_name
          : comp_brands?.brand_name,
        brand_color: comp_brands?.brand_color,
        brand_id: comp_brands?.name ? comp_brands?.name : comp_brands?.brand_id,
      };
      updatedBrandList?.push(parentBrand);
      if (
        comp_brands?.competitorList &&
        Array.isArray(comp_brands?.competitorList)
      ) {
        comp_brands?.competitorList?.forEach((cb) => {
          let cBrand = {
            brand_name: cb?.brand_friendly_name
              ? cb?.brand_friendly_name
              : cb?.brand_name,
            brand_color: cb?.comp_brand_color
              ? cb?.comp_brand_color
              : cb?.brand_color,
            brand_id: cb?.name ? cb?.name : cb?.brand_id,
          };
          updatedBrandList?.push(cBrand);
        });
      }
    }
    return updatedBrandList;
  }, [
    comp_brands,
    comp_brands?.competitorList?.length,
    comp_brands_length,
    refreshUIOnBrandChange,
  ]);
  useEffect(() => {
    if (comptitorBrandList && Array?.isArray(comptitorBrandList)) {
      let visiblePills = [];
      let hiddenPills = [];
      for (let i = 0; i < comptitorBrandList?.length; i++) {
        if (
          (comptitorBrandList?.length > 6 && i < 5) ||
          (comptitorBrandList?.length <= 6 && i < 6)
        ) {
          // show intial parent + 5 compititor brand
          visiblePills?.push(i);
        } else {
          hiddenPills?.push(i);
        }
      }
      setVisiblePills(visiblePills);
      setHiddenPills(hiddenPills);
    }
  }, [comptitorBrandList, refreshUIOnBrandChange]);
  return (
    <div ref={divRefParent} className="comp__brand--container">
      <div ref={divRefInner} className="comp__brand--innerContainer">
        {visiblePills?.map((index) => (
          <div
            className="comp__brand--pill post-label"
            key={index}
            // ref={(el) => (pillsRefs.current[index] = el)}
          >
            {/* {pills[index]} */}
            <div className="d-flex align-items-center">
              <span
                className={`comp__brand--pill-color ${
                  !comptitorBrandList?.[index]?.brand_color
                    ? "comp__brand--pill-defaultBorder"
                    : ""
                }`}
                style={{
                  backgroundColor: comptitorBrandList?.[index]?.brand_color,
                  color: comptitorBrandList?.[index]?.brand_color,
                }}
              />
              <Tooltip title={comptitorBrandList?.[index]?.brand_name}>
                <span className="comp__brand--pill-text">
                  {comptitorBrandList?.[index]?.brand_name?.trim()?.length > 10
                    ? comptitorBrandList?.[index]?.brand_name
                        ?.trim()
                        ?.substr(0, 10) + " ..."
                    : comptitorBrandList?.[index]?.brand_name?.trim()}
                  {/* {comptitorBrandList?.[index]?.brand_name} */}
                </span>
              </Tooltip>
            </div>
          </div>
        ))}
      </div>
      {hiddenPills?.length > 0 && (
        <div className="comp__brand--pill comp__brand--pill-count">
          <Tooltip
            color="#3B5175"
            placement="bottom"
            title={
              <>
                <div
                  className="custom_scroll"
                  style={{
                    maxWidth: "27rem",
                    maxHeight: "23rem",
                    overflow: "auto",
                    scrollBehavior: "smooth",
                  }}
                >
                  {hiddenPills?.length > 0 &&
                    hiddenPills?.map((el, index) => {
                      const isLastElement = index === hiddenPills?.length - 1;
                      return (
                        <div key={index} className="d-flex align-items-center">
                          <span
                            className={`comp__brand--pill-color ${
                              !comptitorBrandList?.[el]?.brand_color
                                ? "comp__brand--pill-defaultBorder"
                                : ""
                            }`}
                            style={{
                              backgroundColor:
                                comptitorBrandList?.[el]?.brand_color,
                              color: comptitorBrandList?.[el]?.brand_color,
                            }}
                          />
                          <Tooltip
                            title={comptitorBrandList?.[el]?.brand_name}
                            placement="right"
                          >
                            <span
                              className="comp__brand--pill-text text-color-default text-ellipsis"
                              style={{ maxWidth: "calc(100% - 2rem)" }}
                            >
                              {comptitorBrandList?.[el]?.brand_name?.trim()
                                ?.length > 10
                                ? comptitorBrandList?.[el]?.brand_name
                                    ?.trim()
                                    ?.substr(0, 10) + " ..."
                                : comptitorBrandList?.[el]?.brand_name?.trim()}
                              {/* {comptitorBrandList?.[index]?.brand_name} */}

                              {/* {!isLastElement && ","} */}
                            </span>
                          </Tooltip>
                        </div>
                      );
                    })}
                </div>
              </>
            }
          >
            <span className="text-ellipsis comp__brand--pill-text">
              +{hiddenPills?.length}
            </span>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default React.memo(CompetitorBrandLabels, isEqual);
